import { DEFAULT_STATE } from '../constants'

export const initialSimulationReadyState = {
  simulationReady: DEFAULT_STATE.simulationReady,
}
